import { SVGProps } from 'react'

export const ChevronRight = ({
  size = 24,
  className,
  ...props
}: SVGProps<SVGSVGElement> & { size?: number }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    className={className}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.97327 19.9732L14.9197 12.0268L6.97327 4.08035L8.02683 3.02679L17.0268 12.0268L8.02683 21.0268L6.97327 19.9732Z"
      fill="currentColor"
    />
  </svg>
)
